module.exports = __webpack_public_path__ + "img/logo.29dd6160.png";